const FETCH_DISTRICTS_REQUEST = "FETCH_DISTRICTS_REQUEST";
const FETCH_DISTRICTS_SUCCESS = "FETCH_DISTRICTS_SUCCESS";
const FETCH_DISTRICTS_FAILURE = "FETCH_DISTRICTS_FAILURE";

export default {
  FETCH_DISTRICTS_REQUEST,
  FETCH_DISTRICTS_SUCCESS,
  FETCH_DISTRICTS_FAILURE,
};
